module.exports = __webpack_public_path__ + "img/DJI_0076_large.621fedb7.jpg";